<script>
import Vue from 'vue';
import events from './events'
import { mapMutations } from 'vuex';

export default {
  name: 'MultiTab',
  data () {
    return {
      fullPathList: [],
      pages: [],
      activeKey: '',
      newTabIndex: 0,
      componentsObj: {}
    }
  },
  watch: {
    $route: function (newPage) {
      // console.log('--watch $route--', newPage)
      const index = this.fullPathList.indexOf(newPage.path)
      if (index < 0) {
        this.fullPathList.push(newPage.path);
        this.pages.push(newPage);

        this.refreshKeepAliveInclude(newPage.name, 'add', newPage.meta.hasRouteView);
      } else {
        this.pages[index] = newPage;
      }

      this.activeKey = newPage.path;
    },

    activeKey: function (newActiveKey) {
      let newPage = this.pages.find(page => page.path === newActiveKey);

      if (Object.keys(newPage.params).length) {
        this.$router.push({ name: newPage.name, params: newPage.params });
        return;
      };
      this.$router.push({ path: newPage.fullPath, query: newPage.query });
    }
  },
  created () {
    // bind event
    events
      .$on('open', val => {
        // console.log('------MultiTab Vue().$on(open)-------', val)
        if (!val) {
          throw new Error(`multi-tab: open tab ${val} err`)
        }      
        this.activeKey = val
      })
      .$on('close', val => {
        // console.log('------MultiTab Vue().$on(close)-------')
        if (!val) {
          this.closeThat(this.activeKey)
          return
        }
        if (this.fullPathList.indexOf(val) === -1) return
        this.closeThat(val)
      })
      .$on('rename', ({ key, name }) => {
        // console.log('------MultiTab Vue().$on(rename)-------', key, name)
        try {
          const item = this.pages.find(item => item.path === key)
          item.meta.customTitle = name
          this.$forceUpdate()
        } catch (e) {}
      })

    this.pages.push(this.$route)
    this.fullPathList.push(this.$route.path)
    this.selectedLastPath();

    // 固定首页
    if (this.pages[0].fullPath !== '/home') {
      this.pages.unshift({
        path: '/home',
        fullPath: '/home',
        name: 'homeIndex',
        hash: '',
        query: {},
        params: {},
        hideInMenu: false,
        meta: { icon: 'home', title: 'router.home', authority: 'homeIndex', bread: true }
      })
      this.fullPathList.unshift('/home');
      this.refreshKeepAliveInclude('homeIndex', 'add', false);
    }

    this.refreshKeepAliveInclude(this.$route.name, 'add', this.$route.meta.hasRouteView);
  },
  methods: {
    ...mapMutations(['setKeepAliveInclude', 'resetKeepAliveInclude']),

    onEdit (targetKey, action) {
      this[action](targetKey)
    },
    remove (targetKey) {
      // 判断当前标签是否首页，如果是则跳转到最后选择的标签页
      if (targetKey === '/home') {
        this.selectedLastPath()
        return false
      }

      let targetPage = this.pages.find(page => page.path === targetKey);
      this.refreshKeepAliveInclude(targetPage.name, 'delete', targetPage.meta.hasRouteView);

      this.pages = this.pages.filter(page => page.path !== targetKey);
      this.fullPathList = this.fullPathList.filter(path => path !== targetKey);

      // 判断当前标签是否关闭，若关闭则跳转到最后一个还存在的标签页
      if (!this.fullPathList.includes(this.activeKey)) {
        this.selectedLastPath()
      }
    },
    selectedLastPath () {
      this.activeKey = this.fullPathList[this.fullPathList.length - 1];
    },

    // content menu
    closeThat (e) {
      // 判断是否为最后一个标签页，如果是最后一个，则无法被关闭
      if (this.fullPathList.length) {
        this.remove(e)
      } else {
        this.$message.info(this.$t('multiTab.noClose'))
      }
    },

    closeLeft (e) {
      const currentIndex = this.fullPathList.indexOf(e)
      if (currentIndex > 0) {
        this.fullPathList.forEach((item, index) => {
          if (index < currentIndex && item !== '/home') {
            this.remove(item)
          }
        })
      } else {
        this.$message.info(this.$t('multiTab.leftNoLabel'))
      }
    },

    closeRight (e) {
      const currentIndex = this.fullPathList.indexOf(e)
      if (currentIndex < (this.fullPathList.length - 1)) {
        this.fullPathList.forEach((item, index) => {
          if (index > currentIndex) {
            this.remove(item)
          }
        })
      } else {
        this.$message.info(this.$t('multiTab.rightNoLabel'))
      }
    },

    closeAll (e) {
      this.fullPathList.forEach((item, index) => {
        if (item !== '/home') {
          this.remove(item)
        }
      })
    },

    closeMenuClick (actionName, route) {
      this[actionName](route)
    },

    renderTabPaneMenu (e) {
      if (e === '/home') return ''

      return (
        <a-menu {...{ on: { click: ({ key, item, domEvent }) => { this.closeMenuClick(key, e) } } }}>
          <a-menu-item key="closeThat">{this.$t('multiTab.closeCurrentBtn')}</a-menu-item>
          <a-menu-item key="closeRight">{this.$t('multiTab.closeRightBtn')}</a-menu-item>
          <a-menu-item key="closeLeft">{this.$t('multiTab.closeLeftBtn')}</a-menu-item>
          <a-menu-item key="closeAll">{this.$t('multiTab.closeAllBtn')}</a-menu-item>
        </a-menu>
      )
    },

    // render
    renderTabPane (title, keyPath) {
      const menu = this.renderTabPaneMenu(keyPath)

      return (
        <a-dropdown overlay={menu} trigger={['contextmenu']}>
          <span style={{ userSelect: 'none' }}>{ title }</span>
        </a-dropdown>
      )
    },

    // 更新store中的 keepAliveInclude
    refreshKeepAliveInclude (name, type, hasRouteView) {
      this.setKeepAliveInclude({ name, type })

      // 用于RouteView里面有嵌套一层RouteView
      if (hasRouteView) this.setKeepAliveInclude({ name: 'RouteView', type })
    }
  },
  render () {
    const { onEdit, $data: { pages } } = this;
    // console.log('--------', pages)
    const panes = pages.map(page => {
      return (
        <a-tab-pane
          style={{ height: 0 }}
          tab={this.renderTabPane(page.meta.customTitle || this.$t(page.meta.title), page.path)}
          key={page.path}
          closable={pages.length > 1 && page.name !== 'homeIndex'}
        >
        </a-tab-pane>)
    })

    return (
      <div class="ant-pro-multi-tab">
        <div class="ant-pro-multi-tab-wrapper">
          <a-tabs
            hideAdd
            type={'editable-card'}
            v-model={this.activeKey}
            style={{ width: '100%' }}
            tabBarStyle={{ background: '#FFF', margin: 0, paddingLeft: '16px', paddingTop: '1px' }}
            {...{ on: { edit: onEdit } }}>
            {panes}
          </a-tabs>
        </div>
      </div>
    )
  }
}
</script>
